import { WithoutSpecialValidation } from "./withoutSpecialValidation";

export class StreetValidation extends WithoutSpecialValidation {
  msgError = "Informe um logradouro válido.";
}
